import { call, put, takeEvery } from "redux-saga/effects";

import {
    POST_OCI_ENABLE_DISABLE_ALERTS,
    POST_OCI_CREATE_RESOURCE_ALERTS,
    POST_OCI_CREATE_DYNAMIC_ALERT,
    GET_OCI_ALERTS,
    GET_OCI_DYNAMIC_ALERTS,
    GET_OCI_MISSING_DYNAMIC_ALERTS,
    GET_OCI_DEFAULT_THRESHOLD,
    GET_OCI_RESOURCE_BY_ID,
    GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    POST_OCI_ALERT,
    GET_OCI_MISSING_ALERT_BY_RESOURCE_ID,
    GET_OCI_ALL_RESOURCE_ALERTS_PAGE,
    GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE,
    POST_OCI_SERVICE_MAPPING,
    POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    GET_ALL_ORG_OCI_RESOURCE_TYPES,
    GET_OCI_RESOURCES,
    POST_UPDATE_OCI_THRESHOLD,
    POST_ENABLE_DISABLE_OCI_THRESHOLD, GET_OCI_RESCAN,
    GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_OCI_THRESHOLD,
    GET_RESCAN_STATUS_OCI
} from "./actionTypes";

import {
    getOciAllResourceAlertsPageFail,
    getOciAllResourceAlertsPageSuccess,
    getOciAllResourceAlertsCountPageFail,
    getOciAllResourceAlertsCountPageSuccess,
    getAllOrgOciResourceTypesSuccess,
    getAllOrgOciResourceTypesFail,
    getOciRefreshSuccess,
    getOciRefreshFail,
    getRescanStatusOciSuccess,
    getRescanStatusOciFail,
    postOciServiceMappingFail,
    postOciServiceMappingSuccess,
    postOciResourceOpsGenieTeamMappingSuccess,
    postOciResourceOpsGenieTeamMappingFail,
    postOciResourcePagerdutyMappingSuccess,
    postOciResourcePagerdutyMappingFail,
    postOciCreateResourceAlertsFail,
    postOciCreateResourceAlertsSuccess,
    postOciEnableDisableAlertsSuccess,
    postOciEnableDisableAlertsFail,
    postOciAlertFail,
    postOciAlertSuccess,
    getOciAlertsFail,
    getOciAlertsSuccess,
    getOciResourceByIdSuccess,
    getOciResourceByIdFail,
    getMissingOciAlertsByResourceIDSuccess,
    getMissingOciAlertsByResourceIDFail,
    getOciResourcesDefaultThresholdByIdFail,
    getOciResourcesDefaultThresholdByIdSuccess,
    getOciMissingDynamicAlertsFail,
    getOciMissingDynamicAlertsSuccess,
    getOciResourcesFail,
    getOciResourcesSuccess,
    getOciThresholdFail,
    getOciThresholdSuccess, postEnableDisableOciThresholdFail, postEnableDisableOciThresholdSuccess,
    postUpdateOciThresholdFail, postUpdateOciThresholdSuccess,
} from "./actions"

import {
    getOciAllResourceAlertsPageUrl,
    getOciAllResourceAlertsCountPageUrl,
    getOciResourceTypesUrl,
    postOciServiceMappingUrl,
    postOciResourceOpsgenieTeamMappingUrl,
    postOciResourcePagerdutyServiceMappingUrl,
    postOciCreateResourceAlertsUrl,
    getOciRefreshUrl,
    getRescanStatusOciUrl,
    getOciMissingAlertByResourceIDUrl,
    postOciEnableDisableAlertsUrl,
    getOciResourceByIDUrl,
    getThresholdsOciResourceByIDUrl,
    getOciMissingAlertsByResourceIDUrl, postOciAlertUrl, getOciAlertByResourceIdUrl,
    getOciResourcesUrl, getOciThresholdUrl, postEnableDisableOciThresholdUrl,
    postUpdateOciThresholdUrl,
} from "helpers/fakebackend_helper";
import {showNotification} from "../../components/Common/notification";

function* onGetOciAllResourceAlertsPage({payload:data}) {
    try{
        const response = yield call(getOciAllResourceAlertsPageUrl, data);
        yield put(getOciAllResourceAlertsPageSuccess(response));
    } catch(error) {
        yield put(getOciAllResourceAlertsPageFail(error))
    }
}

function* onGetOciAllResourceAlertsCountPage({payload:data}) {
    try{
        const response = yield call(getOciAllResourceAlertsCountPageUrl, data)
        yield put(getOciAllResourceAlertsCountPageSuccess(response));
    } catch(error) {
        yield put(getOciAllResourceAlertsCountPageFail(error))
    }
}

function* onGetOciRescan() {
    try{
        const response = yield call(getOciRefreshUrl)
        yield put(getOciRefreshSuccess(response));
    } catch(error) {
        yield put(getOciRefreshFail(error))
    }
}

function* onPostOciServiceMapping({payload:data}) {
    try{
        const response = yield call(postOciServiceMappingUrl, data)
        yield put(postOciServiceMappingSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postOciServiceMappingFail(error))
    }
}

function* onPostOciResourceOpsGenieTeamMapping({payload:data}) {
    try{
        const response = yield call(postOciResourceOpsgenieTeamMappingUrl, data)
        yield put(postOciResourceOpsGenieTeamMappingSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postOciResourceOpsGenieTeamMappingFail(error))
    }
}

function* onPostOciResourcePagerdutyServiceMapping({payload:data}) {
    try{
        const response = yield call(postOciResourcePagerdutyServiceMappingUrl, data)
        yield put(postOciResourcePagerdutyMappingSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postOciResourcePagerdutyMappingFail(error))
    }
}

function* onGetAllOrgOciResourceTypes() {
    try{
        const response = yield call(getOciResourceTypesUrl)
        yield put(getAllOrgOciResourceTypesSuccess(response));
    } catch(error) {
        yield put(getAllOrgOciResourceTypesFail(error))
    }
}

function* onGetRescanStatusOci() {
    try{
        const response = yield call(getRescanStatusOciUrl)
        yield put(getRescanStatusOciSuccess(response));
    } catch(error) {
        yield put(getRescanStatusOciFail(error))
    }
}

function* onPostOciCreateResourceAlerts({payload:data}) {
    try{
        const response = yield call(postOciCreateResourceAlertsUrl, data)
        yield put(postOciCreateResourceAlertsSuccess(response));
    } catch(error) {
        yield put(postOciCreateResourceAlertsFail(error))
    }
}

function* onGetMissingAlertsByResourceID({payload:data}) {
    try{
        const response = yield call(getOciMissingAlertByResourceIDUrl, data)
        yield put(getMissingOciAlertsByResourceIDSuccess(response));
    } catch(error) {
        yield put(getMissingOciAlertsByResourceIDFail(error))
    }
}

function* onGetOciResourceById({payload:data}) {
    try{
        const response = yield call(getOciResourceByIDUrl, data)
        yield put(getOciResourceByIdSuccess(response));
    } catch(error) {
        yield put(getOciResourceByIdFail(error))
    }
}

function* onGetOciResourcesDefaultThresholdById({payload:data}) {
    try{
        const response = yield call(getThresholdsOciResourceByIDUrl, data)
        yield put(getOciResourcesDefaultThresholdByIdSuccess(response));
    } catch(error) {
        yield put(getOciResourcesDefaultThresholdByIdFail(error))
    }
}

function* onPostOciAlert({payload:data}) {
    try{
        const response = yield call(postOciAlertUrl, data)
        yield put(postOciAlertSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postOciAlertFail(error))
    }
}

function* onGetAlertByResourceID({payload:data}) {
    try{
        const response = yield call(getOciAlertByResourceIdUrl, data)
        yield put(getOciAlertsSuccess(response));
    } catch(error) {
        yield put(getOciAlertsFail(error))
    }
}

function* onGetOciResources() {
    try{
        const response = yield call(getOciResourcesUrl)
        yield put(getOciResourcesSuccess(response));
    } catch(error) {
        yield put(getOciResourcesFail(error))
    }
}

function* onGetOciThreshold() {
    try{
        const response = yield call(getOciThresholdUrl)
        yield put(getOciThresholdSuccess(response));
    } catch(error) {
        yield put(getOciThresholdFail(error))
    }
}

function* onPostEnableDisableAlerts({payload:data}) {
    try{
        const response = yield call(postOciEnableDisableAlertsUrl, data)
        yield put(postOciEnableDisableAlertsSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postOciEnableDisableAlertsFail(error))
    }
}

function* onPostEnableDisableThreshold({payload:data}) {
    try{
        const response = yield call(postEnableDisableOciThresholdUrl, data)
        yield put(postEnableDisableOciThresholdSuccess(response));
        if (response){
            showNotification("success", "Threshold updated successfully")
        }
    } catch(error) {
        yield put(postEnableDisableOciThresholdFail(error))
    }
}

function* postUpdateOciThreshold({payload:data}) {
    try{
        const response = yield call(postUpdateOciThresholdUrl, data)
        yield put(postUpdateOciThresholdSuccess(response));
        if (response){
            showNotification("success", "Threshold updated successfully")
            yield put({type: GET_OCI_THRESHOLD})
        }
    } catch(error) {
        yield put(postUpdateOciThresholdFail(error))
    }
}


function* ociSaga() {
    yield takeEvery(GET_OCI_ALL_RESOURCE_ALERTS_PAGE, onGetOciAllResourceAlertsPage)
    yield takeEvery(GET_OCI_ALL_RESOURCE_ALERTS_COUNT_PAGE, onGetOciAllResourceAlertsCountPage)
    yield takeEvery(GET_OCI_RESCAN, onGetOciRescan)
    yield takeEvery(POST_OCI_SERVICE_MAPPING, onPostOciServiceMapping)
    yield takeEvery(POST_OCI_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostOciResourceOpsGenieTeamMapping)
    yield takeEvery(POST_OCI_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostOciResourcePagerdutyServiceMapping)
    yield takeEvery(GET_ALL_ORG_OCI_RESOURCE_TYPES, onGetAllOrgOciResourceTypes)
    yield takeEvery(GET_RESCAN_STATUS_OCI, onGetRescanStatusOci)
    yield takeEvery(POST_OCI_CREATE_RESOURCE_ALERTS, onPostOciCreateResourceAlerts)
    yield takeEvery(GET_OCI_MISSING_ALERTS_BY_RESOURCE_ID, onGetMissingAlertsByResourceID)
    yield takeEvery(GET_OCI_RESOURCE_BY_ID, onGetOciResourceById)
    yield takeEvery(GET_OCI_RESOURCE_DEFAULT_THRESHOLD_BY_ID, onGetOciResourcesDefaultThresholdById)
    yield takeEvery(POST_OCI_ALERT, onPostOciAlert)
    yield takeEvery(GET_OCI_ALERTS, onGetAlertByResourceID)
    yield takeEvery(GET_OCI_RESOURCES, onGetOciResources)
    yield takeEvery(GET_OCI_THRESHOLD, onGetOciThreshold)
    yield takeEvery(POST_OCI_ENABLE_DISABLE_ALERTS, onPostEnableDisableAlerts)
    yield takeEvery(POST_ENABLE_DISABLE_OCI_THRESHOLD, onPostEnableDisableThreshold)
    yield takeEvery(POST_UPDATE_OCI_THRESHOLD, postUpdateOciThreshold)
}
export default ociSaga;
